import { useEffect, useState } from "react";
import { getTmlvData } from "../services/TmlvService";
import { useCreditDraftStore } from "../store/creditDraftStore";

export function useTmlv() {
  const { draft, saveDraft } = useCreditDraftStore();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const tmlvData = await getTmlvData();
      if (tmlvData) {
        // saveDraft ya fusiona internamente con el draft actual del store
        saveDraft(tmlvData);
      }
      setLoading(false);
    })();
  }, [saveDraft]);

  return {
    loading,
    mesUsura: draft?.mesUsura ?? "",
    tasaUsura: draft?.tasaUsura ?? "",
    tasaUsuraTmlvRate: draft?.tasaUsuraTmlvRate ?? "",
  };
}
